import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { testimonials } from '../../utils/testimonials';

const TestimonialRotator = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        minHeight: '160px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(10, 38, 71, 0.05)',
        borderRadius: '16px',
        p: 3,
      }}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
          style={{
            position: 'absolute',
            width: '100%',
            textAlign: 'center',
            padding: '0 16px',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: '0.95rem',
              fontStyle: 'italic',
              color: 'text.secondary',
              marginBottom: 1.5,
              lineHeight: 1.6,
              maxWidth: '100%',
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            "{testimonials[currentIndex].text}"
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              color: 'text.primary',
              fontWeight: 600,
            }}
          >
            — {testimonials[currentIndex].author}
          </Typography>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};

export default TestimonialRotator;
